// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-group input[data-v-1542311e]{display:inline-block}.listaagentes[data-v-1542311e]{max-height:450px!important;overflow-y:scroll}.card-body h3[data-v-1542311e]{color:#448fde;font-size:20px;margin-top:10px;text-align:left}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
